module.exports = __webpack_public_path__ + "static/img/home_cpjfw_bg.acb0b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_bg.png
// module id = CaSZ
// module chunks = 21